import { render, staticRenderFns } from "./vehicle_status_maint.vue?vue&type=template&id=6fb78b94&scoped=true&"
import script from "./vehicle_status_maint.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_maint.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_status_maint.vue?vue&type=style&index=0&id=6fb78b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb78b94",
  null
  
)

export default component.exports